module.exports = __webpack_public_path__ + "img/ws-soft-logo.806137b1.png";